import {
  CategoryOfMenuInterface,
  DigitalMenuInterface,
  OptionsConfigInterface,
} from "@/interface/business/digital-menu.interface";
import { DigitalMenuOptions } from "@/modules/business/digital/options";
import { PermissionsConstrains } from "@/enums/permissions.enum";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import PhoneModule from "@/modules/phone";

export default class DigitalMenu implements DigitalMenuInterface {
  id: string = "";
  banner: string | null = null;
  icon: string | null = null;
  qr_code: string | null = null;
  previewURL: string = "";
  options: OptionsConfigInterface;
  categories: Array<CategoryOfMenuInterface> = [];

  public static MODULE = PermissionsConstrains.BUSINESS_MENU;

  constructor(data?) {
    Object.assign(this, data);
    this.options = new DigitalMenuOptions(data?.options);
  }

  /**
   * Is Edit Mode
   * @return {boolean}
   */
  get isEditMode(): boolean {
    return !!this.id;
  }

  /**
   * Is Edit Mode
   * @return {boolean}
   */
  get isCreateMode(): boolean {
    return !this.id;
  }

  /**
   * Is Menu Ready
   * @return {boolean}
   */
  get isReadyMenu(): boolean {
    return !!this.id && !!this?.qr_code;
  }

  /***
   * Setup the Basic details
   * @return {void}
   */
  setupBasicDetails(): void {
    const business = Storage.get(StorageConstants.BUSINESS);
    this.options.business_name = business?.name || "";
    this.options.basic_info.email = business?.contact_email || "";
    this.options.basic_info.address = business?.address || "";
    this.options.basic_info.phone_number = new PhoneModule(business?.phone) || "";
    this.options.facebook = business?.social?.facebook || "";
    this.options.instagram = business?.social.instagram || "";
  }

  /***
   * Get Json Data
   * @return {any}
   */
  get toJson(): any {
    return {
      ...this,
      options: {
        ...this.options,
        basic_info: {
          ...this.options.basic_info,
          phone_number: this.options.basic_info.phone_number.getInternational(),
        },
      },
    };
  }
}
